module.exports = __webpack_public_path__ + "static/media/video-early-warning-es.74e67b60.vtt";